import Input from '@mui/material/Input';
import PropTypes from 'prop-types';
import * as React from 'react';
import { IMaskInput } from 'react-imask';
import { NumericFormat } from 'react-number-format';

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { mask, onChange, ...other } = props;

    return (
        <IMaskInput
            {...other}
            mask={mask}
            inputRef={ref}
            onAccept={(value) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});

TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const InputPhoneMask = props => {
    const {mask, id, label, value, placeholder, onChange, error} = props

    return (
        <Input
            name="phonemask"
            value={value}
            label={label}
            id={id}
            onChange={onChange}
            placeholder={placeholder}
            error={error}
            inputComponent={TextMaskCustom}
            inputProps={{ mask: mask }}            
        />
    );
}


const NumericFormatCustom = React.forwardRef(
    function NumericFormatCustom( props, ref ) {
        const { onChange, ...other } = props;
    
        return (
            <NumericFormat
                {...other}
                getInputRef={ref}
                onValueChange={(values) => {
                    onChange({
                        target: {
                            name: props.name,
                            value: values.value,
                        },
                    });
                }}
                thousandSeparator
                valueIsNumericString
                prefix=""
            />
        );
});
  
NumericFormatCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export const InputCurrencyMask = props => {
    const {id, label, value, placeholder, onChange, error} = props

    return (
        <Input
            name="currencymask"
            value={value}
            label={label}
            id={id}
            onChange={onChange}
            placeholder={placeholder}
            error={error}
            inputComponent={NumericFormatCustom}
        />
    );
}